<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="data.loading" />
    <a-col v-show="!data.loading" class="height100 flex-1 d-flex flex-column">
      <!-- form header, title  -->
      <a-page-header
        :ghost="false"
        sub-title="Газета"
        @back="() => $router.go(-1)"
      >
        <template slot="extra" />
        <a-row align="middle" class="flex-baseline" style="margin: 0 0 30px 0">
          <a-textarea
            v-model="data.form.title"
            :auto-size="{ minRows: 1, maxRows: 10 }"
            placeholder="Введите заголовок"
            size="small"
            class="ant-page-header-heading-title"
            @input="
              $__slugCompute({
                event: $event,
                langTab: data.form.lang,
                type: 'post',
                title: data.form.title,
                postType: 'news'
              })
            "
          />
          <div v-if="data.isTitleNull" class="error-text">
            Введите заголовок на одном из языков.
          </div>
        </a-row>
        <a-descriptions size="small" :column="3">
          <a-descriptions-item v-if="data.form.id" label="ID">
            {{ data.form.id }}
          </a-descriptions-item>
          <a-descriptions-item v-if="data.form.created" label="Создан">
            {{ moment(form.created).format("DD-MMM YYYY HH:mm") }}
          </a-descriptions-item>
          <a-descriptions-item v-if="data.form.updated" label="Обновлен">
            {{ moment(form.updated).format("DD-MMM YYYY HH:mm") }}
          </a-descriptions-item>
          <a-descriptions-item v-if="data.form.views" label="Просмотры">
            {{ data.form.views }}
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>

      <!-- tabs -->
      <a-tabs
        :key="$route.fullPath"
        class="flex-1"
        type="card"
        @change="$emit('tabPaneChange', arguments[1])"
      >
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>

            <a-col :span="18">
              <lang-tabs v-model="data.form.lang" class="mb-1x" />
            </a-col>
          </a-row>

          <!-- slug -->
          <a-row :class="['flex-baseline']" align="middle">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              ЧПУ:
            </a-col>
            <a-col :span="18" class="sm-mb">
              <a-row align="middle" type="flex">
                <span
                  class="mr-1 link"
                  @click="copySlugToBuffer(data.form.slug)"
                >
                  <a-icon :style="{ fontSize: '22px' }" type="copy" />
                </span>

                <span class="flex-1">
                  <a-col :span="18">
                    <a-input
                      id="slug-input"
                      v-model="data.form.slug"
                      placeholder="Введите человеку понятный урл"
                      @input="$emit('slug-change')"
                    />
                  </a-col>

                  <a-col :span="4">
                    <a-tooltip
                      placement="topLeft"
                      :title="`Генерация ЧПУ на  ${data.form.lang}`"
                    >
                      <a-button
                        :disabled="!data.form.title"
                        class="ml-1"
                        block
                        type="primary"
                        @click="
                          $__slugCompute({
                            event: $event,
                            langTab: data.form.lang,
                            type: 'post',
                            title: data.form.title,
                            postType: 'news'
                          })
                        "
                      >
                        {{ data.langTab }}
                        <a-icon type="reload" />
                      </a-button>
                    </a-tooltip>
                  </a-col>
                </span>
              </a-row>
              <div v-if="!data.form.slug" class="error-text">Введите ЧПУ</div>
            </a-col>
          </a-row>

          <!-- published time -->
          <a-row class="mb-2">
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px; padding-top: 6px"
            >
              Дата публикации:
            </a-col>
            <a-col :span="18">
              <a-date-picker
                v-model="data.form.date"
                :allow-clear="false"
                :format="'DD-MMM YYYY HH:mm'"
                :show-time="{ format: 'HH:mm' }"
              />
            </a-col>
          </a-row>

          <!-- excerpt -->
          <a-row class="mb-2">
            <a-col :span="6" class="form__title__key"> Подзаголовок: </a-col>
            <a-col :span="18">
              <!-- <a-tinymce
                        v-model="data.form.excerpt"
                        :auto-size="{ minRows: 3 }"
                     /> -->
              <editor
                :key="'tinymce_' + tabPane"
                v-model="data.form.excerpt"
                style="
                  padding-top: 4px;
                  text-align: right;
                  padding-right: 8px;
                  overflow: hidden;
                "
                :init="{
                  height: 450,
                  plugins: [
                    'iframe advlist autolink lists link image imagetools charmap print preview',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code wordcount'
                  ],
                  fontsize_formats:
                    '8px 10px 12px 14px 16px 18px 24px 36px 40px 72px',
                  toolbar:
                    'iframe undo redo | preview fullscreen | formatselect fontsizeselect | bold italic underline forecolor | \
                  image link table insertfile code | hr alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | basicDateButton selectiveDateButton toggleDateButton splitDateButton menuDateButton',
                  language: 'ru',
                  language_url: '/js/tinymce/langs/ru.js',
                  menubar: false,
                  images_upload_url: false,
                  automatic_uploads: false,
                  relative_urls: false,
                  images_reuse_filename: true,
                  images_dataimg_filter: function (img) {
                    return img.hasAttribute('internal-blob')
                  },

                  external_plugins: {
                    myplugin:
                      '/js/tinymce/plugins/image-align/editor_plugin_img.js'
                  },

                  image_advtab: true,
                  importcss_append: true,
                  image_caption: true,

                  image_class_list: [
                    {
                      title: 'Some class',
                      value: 'class-name',
                      active: true,
                      selected: true
                    },
                    { title: 'None', value: '' }
                  ]
                  // file_picker_callback: function(callback, value, meta) {
                  //   console.log(callback, value, meta)
                  //   // if (meta.filetype == 'image') {
                  //   //   callback('img.jpg', {alt: 'My alt text'});
                  //   // }
                  // }
                }"
                api-key="3myux81vzip0v5yxik8wex3sk4vgt37xuna840e8nzco3rs5"
              />
            </a-col>
          </a-row>
          <!-- <pre>{{ data }}</pre> -->
        </a-tab-pane>

        <!-- photo tab -->
        <a-tab-pane key="photo">
          <span slot="tab"> <a-icon type="picture" />Фото </span>

          <!-- upload photo -->
          <a-row align="middle">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Изображения
            </a-col>
            <a-col :span="12">
              <image-upload
                :key="Math.random().toString().slice(2)"
                :with-cropper="false"
                :list="c_imagePath"
                accept="image/jpeg, image/png"
                :multiple="false"
                @change="handleImages"
              />
              <!-- @set-main-image="main_image = arguments[0]" -->
              <!-- @drag-update="updateFilesPosition" -->
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- document -->
        <a-tab-pane v-if="!data.form.id" key="files">
          <span slot="tab"> <a-icon type="file" />Файлы </span>

          <a-col>
            <a-row style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Файл:
              </a-col>
              <a-col :span="12">
                <a-button @click="$refs.documentRef.click()">
                  <input
                    ref="documentRef"
                    accept="application/pdf"
                    hidden
                    type="file"
                    @change="emitFile"
                  />
                  <a-icon type="upload" />
                  Выберите файл
                </a-button>

                <InputFileItem
                  v-if="data.file_raw"
                  :file="data.file_raw"
                  class="mt-2"
                  file-secondary-address=""
                  @delete="$emit('document-input', null)"
                />

                <InputFileItem
                  v-else-if="data.form && data.form.file_path"
                  link
                  :file="{
                    name:
                      data.form &&
                      data.form.file_path &&
                      data.form.file_path.split('/').pop()
                  }"
                  class="mt-2"
                  file-secondary-address="newspaper/"
                  @delete="$refs.documentRef.value = document_file = null"
                />

                <!-- @delete="" -->
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>

        <span v-if="data.form.id" slot="tabBarExtraContent">
          <a-button
            :loading="data.pending"
            style="margin-left: 10px"
            type="primary"
            @click="$emit('submit')"
          >
            <a-icon type="check" />
            {{ data.form.id ? "Сохранить" : "Добавить" }}
          </a-button>
          <a-popconfirm
            placement="bottomRight"
            title="Вы действительно хотите удалить данный новость?"
            @confirm="$emit('delete')"
          >
            <a-button :disabled="data.pending" style="margin-right: 10px">
              <a-icon type="delete" />Удалить
            </a-button>
          </a-popconfirm>
        </span>
      </a-tabs>

      <!-- actions -->
      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="data.pending" @click="$router.go(-1)">
            <a-icon type="close" />
            Отмена
          </a-button>

          <a-button
            :loading="data.pending"
            style="margin-left: 10px"
            type="primary"
            @click="$emit('submit')"
          >
            <a-icon type="check" />
            {{ data.form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import Editor from "@tinymce/tinymce-vue"
export default {
  components: {
    "image-upload": () => import("@/components/utils/image-upload"),
    InputFileItem: () => import("@/components/utils/input-file-item"),
    Editor
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tabPane: null
    }
  },

  computed: {
    c_imagePath() {
      if (this.data.image_raw) {
        return [
          {
            fileTarget: this.data.image_raw
          }
        ]
      }

      if (this.data.form.avatar_file) {
        return [
          {
            id: 1,
            file: this.data.form.avatar_file
          }
        ]
      }

      if (this.data.form.image_path) {
        return [
          {
            id: 1,
            file: this.data.form.image_path
          }
        ]
      }
      return []
    }
  },

  methods: {
    emitFile(e) {
      if (e.target.files != 0) {
        this.$emit("document-input", e.target.files[0])
      }

      this.$refs.documentRef.value = null
    },

    handleImages(e) {
      // console.log('hi', e);
      this.$emit("avatar-file", e && e != 0 && e[0].fileTarget)
    }
  }
}
</script>
